<app-navbar-style-two></app-navbar-style-two>

<section class="brands-hero">
  <div class="container-fluid">
    <h1 class="text-white">UNIKAI Careers</h1>
    <h3>Build Your Future with UNIKAI.</h3>
  </div>
</section>

<div class="career-container">
  <!-- Country Select -->
  <div class="section-title">Application for Careers</div>
  <p class="section-main-title">Select Country</p>

  <div class="country-box">
    <p class="section-subtitle">Country <span class="required">*</span></p>

    <div class="country-box-item">
      <label>
        <input type="radio" name="country" value="UAE" (change)="changeCountry('UAE')" [checked]="country === 'UAE'">
        <span>UAE</span>
      </label>

      <label>
        <input type="radio" name="country" value="OMAN" (change)="changeCountry('OMAN')" [checked]="country === 'OMAN'">
        <span>Oman</span>
      </label>      
    </div>
  </div>

  <!-- OMAN Form -->
  <form [formGroup]="omanForm" (ngSubmit)="onSubmit()" *ngIf="country === 'OMAN'">
    <!-- City & Department -->
    <div class="details-box">
      <div class="grid-2">
        <div class="form-group">
          <label class="section-subtitle">City / Emirates <span class="required">*</span></label>
          <select class="no-nice-select" formControlName="city">
            <option value="" disabled>Select City</option>
            <option *ngFor="let c of ocities" [value]="c">
              {{ c }}
            </option>
          </select>
        </div>

        <div class="form-group">
          <label class="section-subtitle">Preferred Department <span class="required">*</span></label>
          <select class="no-nice-select" formControlName="department">
            <option value="" disabled>Select Department</option>
            <option *ngFor="let d of departments.OMAN" [value]="d">
              {{ d }}
            </option>
          </select>
        </div>
      </div>
    </div>


    <!-- Personal Info Section -->
    <div class="section-main-title mt-5">Personal Information</div>

    <div class="details-box-start">
      <div class="grid-2">
        <div class="form-group">
          <label>Name <span class="required">*</span></label>
          <input formControlName="name" type="text" placeholder="Name">
        </div>

        <div class="form-group">
          <label>Nationality <span class="required">*</span></label>
          <input formControlName="nationality" type="text" placeholder="Nationality">
        </div>
      </div>
    </div>

    <div class="details-box">
      <div class="grid-2">
        <div class="form-group">
          <label>Age <span class="required">*</span></label>
          <input formControlName="age" type="number" placeholder="Age">
        </div>

        <div class="form-group">
          <label>Gender <span class="required">*</span></label>
          <select class="no-nice-select" formControlName="gender">
            <option value="" disabled>Select Gender</option>
            <option value="Male">Male</option>
            <option value="Female">Female</option>
            <!-- <option value="Other">Other</option> -->
          </select>
        </div>
      </div>
    </div>

    <div class="details-box">
      <div class="grid-2">
        <div class="form-group">
          <label>Date of Birth <span class="required">*</span></label>
          <input formControlName="dob" type="date">
        </div>

        <div class="form-group">
          <label>Email Address <span class="required">*</span></label>
          <input formControlName="email" type="email" placeholder="Mail">
        </div>
      </div>
    </div>

    <div class="details-box">
      <div class="grid-2">
        <div class="form-group">
          <label>Mobile Number <span class="required">*</span></label>
          <ngx-intl-tel-input
            cssClass="career-phone-input"
            [preferredCountries]="preferredPhoneCountries"
            [selectedCountryISO]="defaultPhoneCountry"
            [searchCountryFlag]="false"
            [enablePlaceholder]="true"
            [maxLength]="15"
            [phoneValidation]="false"
            [inputId]="'career-mobile1-' + country"
            formControlName="mobile1">
          </ngx-intl-tel-input>
          <small class="text-danger" *ngIf="getCurrentForm().get('mobile1')?.invalid && getCurrentForm().get('mobile1')?.touched">
            Valid phone required ({{ PHONE_NATIONAL_MIN }}-{{ PHONE_NATIONAL_MAX }} digits)
          </small>
        </div>

        <div class="form-group">
          <label>Mobile Number 2</label>
          <ngx-intl-tel-input
            cssClass="career-phone-input"
            [preferredCountries]="preferredPhoneCountries"
            [selectedCountryISO]="defaultPhoneCountry"
            [searchCountryFlag]="false"
            [enablePlaceholder]="true"
            [maxLength]="15"
            [phoneValidation]="false"
            [inputId]="'career-mobile2-' + country"
            formControlName="mobile2">
          </ngx-intl-tel-input>
        </div>
      </div>
    </div>

    <div class="details-box">
      <!-- Current Location -->
      <div class="grid-2">
        <div class="form-group">
          <label>Current Location (Country)</label>
          <input formControlName="currentCountry" type="text" placeholder="Country">
        </div>

        <div class="form-group">
          <label>Current Location (City)</label>
          <input formControlName="currentCity" type="text" placeholder="City">
        </div>
      </div>
    </div>

    <div class="details-box">
      <div class="grid-2">
        <div class="form-group">
          <label>Current Employer</label>
          <input formControlName="employer" type="text" placeholder="Current Employer">
        </div>

        <div class="form-group">
          <label>Current Position</label>
          <input formControlName="position" type="text" placeholder="Current Position">
        </div>
      </div>
    </div>

    <div class="details-box">
      <div class="grid-2">
        <div class="form-group">
          <label>Total Years of Experience <span class="required">*</span></label>
          <input formControlName="experience" type="number" placeholder="Select Experience">
        </div>

        <div class="form-group">
          <label>Upload CV (PDF only)<span class="required">*</span></label>
          <input formControlName="cv" type="file" accept=".pdf" (change)="onCvChange($event)">
          
        </div>
      </div>
    </div>

    <div class="details-box-end">
      <!-- Education & Driving -->
      <div class="grid-2">
        <div class="form-group">
          <label>Education <span class="required">*</span></label>
          <select class="no-nice-select" formControlName="education">
            <option value="" disabled>Select Education</option>
            <option *ngFor="let e of educationList" [value]="e">{{ e }}</option>
          </select>
        </div>

        <div class="form-group">
          <label>Driving License <span class="required">*</span></label>
          <select class="no-nice-select" formControlName="driving">
            <option value="" disabled>Select License</option>
            <option *ngFor="let d of drivingOm" [value]="d">
              {{ d }}
            </option>
          </select>
        </div>
      </div>
    </div>

    <!-- Additional Information  -->
    <p class="section-main-title mt-5">Additional Information</p>

    <div class="details-box-start">
      <div class="grid-2">
        <div class="form-group">
          <label>Do you have any health issues? <span class="required">*</span></label>
          <select class="no-nice-select" formControlName="health">
            <option value="" disabled>Please Select</option>
            <option *ngFor="let h of healthOptions" [value]="h">{{ h }}</option>
          </select>
        </div>

        <div class="form-group">
          <label>Do you have any relative working at Unikai Company? <span class="required">*</span></label>
          <select class="no-nice-select" formControlName="relative">
            <option value="" disabled>Please Select</option>
            <option *ngFor="let r of relativeOptions" [value]="r">{{ r }}</option>
          </select>
        </div>
      </div>
    </div>
    <div class="details-box-end">
      <div class="grid-1">
        <!-- NOC for OMAN -->
        <div class="form-group">
          <label>Can you provide new NOC from ROP? <span class="required">*</span></label>
          <select class="no-nice-select" formControlName="noc">
            <option value="" disabled>Please Select</option>
            <option *ngFor="let n of nocOptions" [value]="n">{{ n }}</option>
          </select>
        </div>
      </div>
    </div>

    <p class="note">
      Note: By submitting this information you confirm that all the details provided are true & accurate.
    </p>

    <button type="submit" class="submit-btn" [disabled]="submitting">
      {{ submitting ? 'SUBMITTING...' : 'SUBMIT' }}
    </button>

    <div *ngIf="submitError" class="text-danger mt-2">
      {{ submitError }}
    </div>
  </form>

  <!-- UAE Form -->
  <form [formGroup]="uaeForm" (ngSubmit)="onSubmit()" *ngIf="country === 'UAE'">
    <!-- City & Department -->
    <div class="details-box">
      <div class="grid-2">
        <div class="form-group">
          <label class="section-subtitle">City / Emirates <span class="required">*</span></label>
          <select class="no-nice-select" formControlName="city">
            <option value="" disabled>Select City</option>
            <option *ngFor="let c of ucities" [value]="c">
              {{ c }}
            </option>
          </select>
        </div>

        <div class="form-group">
          <label class="section-subtitle">Preferred Department <span class="required">*</span></label>
          <select class="no-nice-select" formControlName="department">
            <option value="" disabled>Select Department</option>
            <option *ngFor="let d of departments.UAE" [value]="d">
              {{ d }}
            </option>
          </select>
        </div>
      </div>
    </div>

    <!-- Personal Info Section -->
    <p class="section-main-title mt-5">Personal Information</p>

    <div class="details-box-start">
      <div class="grid-2">
        <div class="form-group">
          <label>Name <span class="required">*</span></label>
          <input formControlName="name" type="text" placeholder="Name">
        </div>

        <div class="form-group">
          <label>Nationality <span class="required">*</span></label>
          <input formControlName="nationality" type="text" placeholder="Nationality">
        </div>
      </div>
    </div>

    <div class="details-box">
      <div class="grid-2">
        <div class="form-group">
          <label>Age <span class="required">*</span></label>
          <input formControlName="age" type="number" placeholder="Age">
        </div>

        <div class="form-group">
          <label>Gender <span class="required">*</span></label>
          <select class="no-nice-select" formControlName="gender">
            <option value="" disabled>Select Gender</option>
            <option value="Male">Male</option>
            <option value="Female">Female</option>
            <!-- <option value="Other">Other</option> -->
          </select>
        </div>
      </div>
    </div>

    <div class="details-box">
      <div class="grid-2">
        <div class="form-group">
          <label>Date of Birth <span class="required">*</span></label>
          <input formControlName="dob" type="date">
        </div>

        <div class="form-group">
          <label>Email Address <span class="required">*</span></label>
          <input formControlName="email" type="email" placeholder="Mail">
        </div>
      </div>
    </div>

    <div class="details-box">
      <div class="grid-2">
        <div class="form-group">
          <label>Mobile Number <span class="required">*</span></label>
          <ngx-intl-tel-input
            cssClass="career-phone-input"
            [preferredCountries]="preferredPhoneCountries"
            [selectedCountryISO]="defaultPhoneCountry"
            [searchCountryFlag]="false"
            [enablePlaceholder]="true"
            [maxLength]="15"
            [phoneValidation]="true"
            [inputId]="'career-mobile1-' + country"
            formControlName="mobile1">
          </ngx-intl-tel-input>
          <small class="text-danger" *ngIf="getCurrentForm().get('mobile1')?.invalid && getCurrentForm().get('mobile1')?.touched">
            Valid phone required ({{ PHONE_NATIONAL_MIN }}-{{ PHONE_NATIONAL_MAX }} digits)
          </small>
        </div>

        <div class="form-group">
          <label>Mobile Number 2</label>
          <ngx-intl-tel-input
            cssClass="career-phone-input"
            [preferredCountries]="preferredPhoneCountries"
            [selectedCountryISO]="defaultPhoneCountry"
            [searchCountryFlag]="false"
            [enablePlaceholder]="true"
            [maxLength]="15"
            [phoneValidation]="true"
            [inputId]="'career-mobile2-' + country"
            formControlName="mobile2">
          </ngx-intl-tel-input>
        </div>
      </div>
    </div>

    <div class="details-box">
      <!-- Current Location -->
      <div class="grid-2">
        <div class="form-group">
          <label>Current Location (Country)</label>
          <input formControlName="currentCountry" type="text" placeholder="Country">
        </div>

        <div class="form-group">
          <label>Current Location (City)</label>
          <input formControlName="currentCity" type="text" placeholder="City">
        </div>
      </div>
    </div>

    <div class="details-box">
      <div class="grid-2">
        <div class="form-group">
          <label>Current Employer</label>
          <input formControlName="employer" type="text" placeholder="Current Employer">
        </div>

        <div class="form-group">
          <label>Current Position</label>
          <input formControlName="position" type="text" placeholder="Current Position">
        </div>
      </div>
    </div>

    <div class="details-box">
      <div class="grid-2">
        <div class="form-group">
          <label>Total Years of Experience <span class="required">*</span></label>
          <input formControlName="experience" type="number" placeholder="Select Experience">
        </div>

        <div class="form-group">
          <label>Upload CV (PDF only)<span class="required">*</span></label>
          <input formControlName="cv" type="file" accept=".pdf" (change)="onCvChange($event)">
        </div>
      </div>
    </div>

    <div class="details-box-end">
      <!-- Education & Driving -->
      <div class="grid-2">
        <div class="form-group">
          <label>Education <span class="required">*</span></label>
          <select class="no-nice-select" formControlName="education">
            <option value="" disabled>Select Education</option>
            <option *ngFor="let e of educationList" [value]="e">{{ e }}</option>
          </select>
        </div>

        <div class="form-group">
          <label>Driving License <span class="required">*</span></label>
          <select class="no-nice-select" formControlName="driving">
            <option value="" disabled>Select License</option>
            <option *ngFor="let d of drivingUae" [value]="d">
              {{ d }}
            </option>
          </select>
        </div>
      </div>
    </div>

    <!-- Additional Information -->
    <p class="section-main-title mt-5">Additional Information</p>

    <div class="details-box-start">
      <div class="grid-2">
        <div class="form-group">
          <label>Do you have any health issues? <span class="required">*</span></label>
          <select class="no-nice-select" formControlName="health">
            <option value="" disabled>Please Select</option>
            <option *ngFor="let h of healthOptions" [value]="h">{{ h }}</option>
          </select>
        </div>

        <div class="form-group">
          <label>Do you have any relative working at Unikai Company? <span class="required">*</span></label>
          <select class="no-nice-select" formControlName="relative">
            <option value="" disabled>Please Select</option>
            <option *ngFor="let r of relativeOptions" [value]="r">{{ r }}</option>
          </select>
        </div>
      </div>
    </div>

    <div class="details-box-end">
      <div class="grid-1">
        <!-- NOC not required for UAE, but field exists -->
        <div class="form-group">
          <label>Have you completed more than six months of employment with your current UAE employer?</label>
          <select class="no-nice-select" formControlName="noc">
            <option value="" disabled>Please Select</option>
            <option *ngFor="let n of nocOptions" [value]="n">{{ n }}</option>
          </select>
        </div>
      </div>
    </div>

    <p class="note">
      Note: By submitting this information you confirm that all the details provided are true & accurate.
    </p>

    <button type="submit" class="submit-btn" [disabled]="submitting">
      {{ submitting ? 'SUBMITTING...' : 'SUBMIT' }}
    </button>

    <div *ngIf="submitError" class="text-danger mt-2">
      {{ submitError }}
    </div>
  </form>
</div>

<app-footer-style-one></app-footer-style-one>